import { useQueryClient } from "@tanstack/react-query";
import { editListing } from "../../api";
import { EditListingDTO } from "../../dtos";
import { Listing } from "../../types";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useEditListing() {
  const queryClient = useQueryClient();

  const mutationEditPropertyPrice = useDomainMutation<
    AxiosResponse<Listing>,
    { response?: { data?: { message?: string } } },
    { uid: string; data: EditListingDTO }
  >({
    mutationFn: ({ uid, data }: { uid: string; data: EditListingDTO }) =>
      editListing(uid, data),
    onSuccess: (_, { data }) => {
      queryClient.invalidateQueries({ queryKey: ["listings"] });
      if (data.property) queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationEditPropertyPrice;
}
